import $ from 'jquery';
import constants from 'Constants.js';
import Immutable from 'immutable';
import BasePropertyView from 'BasePropertyView.js';
import valueTemplate from 'properties/main/number.ejs';
import TextUtil from 'util/TextUtil.js';

class MainNumberView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = valueTemplate;
        this.tagName = 'div';
        this.id = opts.el;
        this.config = opts.config || {};

        this.events = {
            'change input[type=text]' : 'updateAttributes',
            'change input[type=number]' : 'updateAttributes',
            'blur input[type=text], input[type=number]'   : 'lostFocus',
            'focus input[type=text], input[type=number]'   : 'getFocus',
            'change #stepSize'          : 'updateAttributes'
        };

        if (!this.model.get('value')) {
            this.model.set('value', '1', {silent: true});
        }

        if (!this.model.get('min')) {
            this.model.set('min', '1', {silent: true});
        }

        if (!this.model.get('max')) {
            this.model.set('max', '10', {silent: true});
        }

        if (!this.model.get('stepSize')) {
            this.model.set('stepSize', '1', {silent: true});
        }

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        let propName = ev.currentTarget.name;
        let propVal  = ev.currentTarget.value;

        if(!TextUtil.isNumeric(propVal)){
            let lastValue=this.model.get(propName);
            this.model.set( propName, lastValue,{silent:true} );
            $('input[name="'+propName+'"]').val(lastValue);
            return;
        }

        if(ev.currentTarget.name.toLowerCase()==="value"){
            let min=parseInt(this.model.get('min'));
            let max=parseInt(this.model.get('max'));

            if(parseInt(propVal)<min){
                propVal=min;
            }
            if(parseInt(propVal)>max){
                propVal=max;
            }
            $('input[name="'+propName+'"]').val(propVal);
        }

        this.model.set( propName, propVal );
    }

    updateForm() {
        if (this.model.get('stepSize')) {
            const q = `option[value="${this.model.get('stepSize')}"]`;
            $('#stepSize').find(q).attr('selected', true);
        }
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }
        this.prepareComboWidget(this.$el);
        let stepSize=this.model.get('stepSize');

        $("#stepSize", this.$el).combobox({
            value: stepSize,
            change: (e, param) => {
                this.model.set('stepSize', param.value);
            }
        });
        this.updateForm();
        if (this.config.showTitle) {
            this.$el.find('.propTitle').removeClass('hide');
        }

        this.delegateEvents();
        return this;
    }

    prepareComboWidget($el) {
        $.widget("custom.combobox", {
            _create: function () {
                this.wrapper = $("<span>")
                    .addClass("custom-combobox")
                    .insertAfter(this.element);

                this.element.hide();
                this._createAutocomplete(this.options);
                this._createShowAllButton();
            },

            _createAutocomplete: function (options) {
                var selected = this.element.children(":selected");

                this.input = $("<input>", {
                    maxLength: 3
                })
                    .appendTo(this.wrapper)
                    .addClass("custom-combobox-input ui-widget ui-widget-content ui-corner-left")
                    .val(options.value)
                    .autocomplete({
                        classes: {
                            "ui-autocomplete": "custom-autocomplete"
                        },
                        delay: 0,
                        minLength: 0,
                        source: $.proxy(this, "_source"),
                        appendTo: $el,
                        search: options.value
                    });

                this._on(this.input, {
                    input: function (e, param) {
                        var value = e.currentTarget.value.replace(/[^[0-9]+(\.[0-9]{1,2})?$]/g, '');

                        this.input.val(value);
                        this.element.val(value);
                        this.input.autocomplete( "disable" );
                    }, //PF-2105 - Forms/Reports - Font size (general)
                    change: function(e, param){
                        var value = e.currentTarget.value.replace(/[^[0-9]+(\.[0-9]{1,2})?$]/g, '');
                        this._trigger("change", null, { value: value });
                        this._trigger("select", e, { item: value });
                    },
                    autocompleteselect: function (event, ui) {
                        ui.item.option.selected = true;
                        this._trigger("change", null, { value: ui.item.value });
                        this._trigger("select", event, { item: ui.item.option });
                    }
                });
            },

            _createShowAllButton: function () {
                var input = this.input,
                    element = this.element,
                    wasOpen = false;

                $("<a>")
                    .attr("tabIndex", -1)
                    .appendTo(this.wrapper)
                    .button({
                        icons: {
                            primary: "ui-icon-triangle-1-s"
                        },
                        text: false
                    })
                    .removeClass("ui-corner-all")
                    .addClass("custom-combobox-toggle ui-corner-right")
                    .on("mousedown", function () {
                        wasOpen = input.autocomplete("widget").is(":visible");
                    })
                    .on("click", function () {
                        input.trigger("focus");

                        // Close if already visible
                        if (wasOpen) {
                            return;
                        }
                        // Pass empty string as value to search for, displaying all results
                        input.autocomplete("search", "20");
                    });
            },

            _source: function (request, response) {
                response(this.element.children("option").map(function () {
                    var text = $(this).text();
                    return {
                        label: text,
                        value: text,
                        option: this
                    };
                }));
            },

            _destroy: function () {
                this.wrapper.remove();
                this.element.show();
            }
        });
    }

}

export default MainNumberView;
